import { useCallback, useEffect, MutableRefObject } from 'react';
import { useAppDispatch, useAppSelector } from './hooks';
import { setFieldFocusFromJSApi } from '../store/JSApiSlice';
import { enforceFocus } from '../utils/dom';

const useFocus = <T extends HTMLElement | HTMLElement[]>(
  el: MutableRefObject<T | null>,
): [() => void] => {
  const dispatch = useAppDispatch();
  const focusFieldId = useAppSelector(
    (state) => state.JSApiSlice.fieldFocusTo.focusFieldId,
  );

  const setFocus = useCallback(() => {
    if (Array.isArray(el.current)) {
      console.log(el.current);
      void enforceFocus(el.current[0]);
      el.current[0]?.scrollIntoView({ block: 'center' });
      if (
        document.activeElement?.id === el.current[0]?.id ||
        document.activeElement?.id === el.current[0]?.dataset.fieldId
      ) {
        dispatch(setFieldFocusFromJSApi({ focusFieldId: null }));
      }
    } else if (el.current) {
      console.log(el.current);
      void enforceFocus(el.current);
      el.current?.scrollIntoView({ block: 'center' });
      if (
        document.activeElement?.id === el.current?.id ||
        document.activeElement?.id === el.current?.dataset.fieldId
      ) {
        dispatch(setFieldFocusFromJSApi({ focusFieldId: null }));
      }
    }
  }, [dispatch, el]);

  useEffect(() => {
    // set focus on element
    if (Array.isArray(el.current)) {
      if (
        focusFieldId === el.current[0]?.id ||
        focusFieldId === el.current[0]?.dataset.fieldId
      ) {
        setFocus();
      }
    } else if (
      focusFieldId === el.current?.id ||
      focusFieldId === el.current?.dataset?.fieldId
    ) {
      setFocus();
    }
  }, [focusFieldId, el, setFocus]);

  return [setFocus];
};

export default useFocus;
